"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpotWorkerStore = useSpotWorkerStore;
const vue_1 = require("vue");
const provider_1 = require("../provider");
function useSpotWorkerStore() {
    const store = (0, vue_1.inject)(provider_1.spotWorkerStoreKey);
    if (!store) {
        throw new Error("SpotWorkerStore not provided");
    }
    return store;
}
